const API_PREFIX = '/api/v1'

export const getApiUrl = (...args) => {
  if (args.length !== 1) {
    throw new Error('wrong number of arguments for utils.getApiUrl')
  }
  const path = args[0]
  return `${API_PREFIX}${path}`
}
